module.exports = __webpack_public_path__ + "img/LogoIbillete_Gris.ff0e1f8f.png";